import { usePublications } from './usePrograms.vm';
import { Button, FormControl, FormControlLabel, Grid, Switch } from '@mui/material';
import { CardComponent } from '../../../../shared/card/cardOther/CardOther';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Add } from '@mui/icons-material';
import { useModal } from '../../../../shared/modal/useModal';
import { ProgramsModal } from './modal/ProgramsModal';
import { checkRoles } from '../../../../../utils/checkRoles';
import { RoleFunction } from '../../../../../constants/projectUsers';

export const Programs = observer(() => {
  const { handleClose, open, handleOpen, id, typeModal } = useModal();
  const {
    articles,
    roleFunction,
    handleDelete,
    handleChange,
    checked,
    handleEdit,
    handleClickByGuest
  } = usePublications(handleOpen);

  return (
    <Grid container pt={1}>
      {checkRoles(roleFunction, RoleFunction.ROLE_ACCEPTING) &&
        <Grid item mt={2} mb={2} alignItems={'flex-end'} ml={'auto'}>
          <FormControl>
            <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  onChange={handleChange}
                />
              }
              label='Dostęp tylko dla PWZ'
            />
          </FormControl>
          <Button disabled={false} startIcon={<Add />} variant='contained' color={'primary'}
                  onClick={() => handleOpen('add')}>DODAJ</Button>
        </Grid>}
      <Grid container>
        {articles && articles.length > 0 && articles.map(el => (
          <Grid item xs={12} md={6} p={1} key={el.id} minHeight={'298px'}>
            <CardComponent
              isActive={el.categoryIsActive}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
              id={el.id}
              handleClickByGuest={handleClickByGuest}
              type={el.categoryMedicaments?.toLowerCase()}
              image={el.nameImg}
              imgHeight={'200px'}
              date={el.date || ''}
              link={process.env.REACT_APP_IMAGE_URL + `${el.pathFile}${el.namePDF}`}
              title={el.title}
            />
          </Grid>
        ))}
      </Grid>
      {open && <ProgramsModal id={id} typeModal={typeModal} open={open} handleClose={handleClose} />}
    </Grid>
  );
});